import { React } from "react";
const Estádisticas2025 = ({ nombre, mdstatus, eseditable }) => {
    return(
        <div className=" w-full h-full">
        <iframe title="Estádisticas2025" className=" w-full h-full border-0"
        src="https://lookerstudio.google.com/embed/reporting/09b12388-889a-4c09-94b8-d3798b0ae388/page/page_12345"
        allowfullscreen sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe></div>
    )
}
export default Estádisticas2025;